import { all, call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import { fetchSubmittedToTypistVisitsAPI } from '../../../services/group-admin-service';
import { FETCH_SUBMITTED_TO_TYPIST_VISITS, FETCH_SUBMITTED_TO_TYPIST_VISITS_ERROR, FETCH_SUBMITTED_TO_TYPIST_VISITS_START, FETCH_SUBMITTED_TO_TYPIST_VISITS_SUCCESS, SET_SUBMITTED_TO_TYPIST_VISITS_PAGINATION } from '../../actions/groupadmin/submittedToTypistActions';

function* fetchSubmittedToTypistVisits({ payload }) {
    try {
        yield put({ type: FETCH_SUBMITTED_TO_TYPIST_VISITS_START })
        let response = yield call(fetchSubmittedToTypistVisitsAPI, payload);
        if (response.data) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalIstems,
            }
            yield put({ type: FETCH_SUBMITTED_TO_TYPIST_VISITS_SUCCESS, submittedToTypist: response.data.submittedToTypist })
            yield put({ type: SET_SUBMITTED_TO_TYPIST_VISITS_PAGINATION, pagination });
        } else {
            yield put({ type: FETCH_SUBMITTED_TO_TYPIST_VISITS_ERROR });
            message.error('Failed to fetch submitted to typist visits!');
        }

    } catch (error) {
        message.error('Failed to fetch submitted to typist visits!');
        yield put({ type: FETCH_SUBMITTED_TO_TYPIST_VISITS_ERROR, error })
    }

}

function* fetchSubmittedToTypistVisitsWatcher() {
    yield takeLatest(FETCH_SUBMITTED_TO_TYPIST_VISITS, fetchSubmittedToTypistVisits)
}

export default function* rootSaga() {
    yield all([
        fetchSubmittedToTypistVisitsWatcher()
    ]);
}